export default import.meta.ROLLDOWN_FILE_URL_VfhFNkeSXSWZqtbgs1Jx7A